import { render, staticRenderFns } from "./SendAudio.vue?vue&type=template&id=29a823d8&scoped=true&"
import script from "./SendAudio.vue?vue&type=script&lang=js&"
export * from "./SendAudio.vue?vue&type=script&lang=js&"
import style0 from "./SendAudio.vue?vue&type=style&index=0&id=29a823d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a823d8",
  null
  
)

export default component.exports